import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

// MCP OAuth endpoints proxy through api.foreplay.co (the internal server holds
// the master API key for public.api.foreplay.co server-to-server).
// Frontend sends Firebase Bearer; the internal server validates the user and
// forwards the request with the master key.

// The internal server reads the user identity from X-Foreplay-User-Token (NOT
// Authorization). The Authorization slot on the upstream call is reserved for
// the master API key, which is attached server-side on api.foreplay.co — never
// in the browser.
const getAuthHeader = async () => {
  const user = firebase.auth().currentUser
  if (!user) throw new Error('Not authenticated')
  const token = user.Aa || (await user.getIdToken())
  return { 'X-Foreplay-User-Token': `Bearer ${token}` }
}

// POST /api/mcp-oauth/users/link
export const linkUser = async ({ foreplayUserId, email, username, keycloakUserId }) => {
  const headers = await getAuthHeader()
  const body = {
    foreplay_user_id: foreplayUserId,
    email,
    username
  }
  if (keycloakUserId) {
    body.keycloak_user_id = keycloakUserId
  }

  const { data } = await AxiosConfig.post(
    '/api/mcp-oauth/users/link',
    body,
    { headers }
  )

  return data
}

// GET /api/mcp-oauth/authorize-url
export const getAuthorizeUrl = async (oauthParams) => {
  const headers = await getAuthHeader()
  const { data } = await AxiosConfig.get(
    '/api/mcp-oauth/authorize-url',
    { params: oauthParams, headers }
  )

  return data
}

// GET /api/mcp-oauth/connections
export const listConnections = async ({ foreplayUserId, first = 0, limit = 50 }) => {
  const headers = await getAuthHeader()
  const { data } = await AxiosConfig.get(
    '/api/mcp-oauth/connections',
    {
      params: {
        foreplay_user_id: foreplayUserId,
        first,
        limit
      },
      headers
    }
  )

  return data
}

export default {
  linkUser,
  getAuthorizeUrl,
  listConnections
}
